import * as React               from "react";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

import "./text-generation-feedback.scss";

import { cs }                               from "@Common/react/chain-services";
import {UseState}                           from "@Common/react/use-state";
import {consumeContext}                     from "@Common/react/context";

export const TextGenerationFeedback = ({
    toolUsed,
    idOrder,
    userCue,
    gptResponse,
    responseCode,
    userDetails,
    feedbackType,
    setFeedbackSent,
    closeModal,
}:
{
    toolUsed:          string,
    idOrder:           number,
    userCue:           string,
    gptResponse:       string,
    responseCode:      string,
    userDetails:       string,
    feedbackType:      string,
    setFeedbackSent:   Function,
    closeModal:        Function,
}) => cs(
    consumeContext("apis"),
    ["feedbackText", ({}, next) => UseState({initValue: "", next})],
    ["changeHandler", ({feedbackText}, next) => next(
        (event) => {
            feedbackText.onChange(event.target.value);
        }
    )],

    ({apis, feedbackText, changeHandler}) => (
        <div className="text-generation-feedback-27g">
            <div className="content-container">
                <div className="header">
                    Help us make our AI tools even better. What did you try to accomplish?
                </div>
                <div className="user-feedback-cont">
                    <input type="text" value={feedbackText.value} className="user-feedback-input" onChange={changeHandler} xd-qa-type="text_field" xd-qa-name="user-feedback-input"/>
                    <div  className="send-button"
                        xd-qa-type="button"
                        xd-qa-name="send"
                        onClick={async () => {
                        setFeedbackSent();
                        await apis.next.gpt.logAiInteraction({
                            "toolUsed": toolUsed,
                            "idOrder": idOrder,
                            "userDetails": userDetails,
                            "userCue": userCue,
                            "gptResponse": gptResponse,
                            "responseCode": responseCode,
                            "feedbackType": feedbackType,
                            "feedbackText": feedbackText.value
                        });
                    }}>Send</div>
                </div>
            </div>
            <div className="close-container">
                <FontAwesomeIcon icon={faXmark} size="xl" className="feedback-thumb" onClick={() => {closeModal();}}/>
            </div>
        </div>
    )
)